export const routes = {
  HOME: '/',
  USERS: '/users',
  PROJECTS: '/projects',
  DASHBOARD: '/dashboard',
  REPORTING: '/reporting',
  BALANCE_SHEET: '/balance_sheet',
  HISTORY: '/history',
  DOCUMENTS: '/documents'
};
export const subRoutes = {
  // DOCUMENTS: {
  //   // SCAN: '/scan',
  //   TEMPLATES: '/templates',
  //   GED: '/ged'
  // }
};
export const outOfNavRoutes = {
  LOGIN: '/login',
  CONFIRMATION: '/email-confirmation',
  PROFILE: '/profile',
  SETTINGS: '/settings'
};
